import React from "react";
import ReactDom from "react-dom";
import _ from "lodash";
import { Navigation, Link } from "react-router";
import queryString from 'query-string'

var LI = React.createClass({
  displayName: "LI",

  propTypes: {
    click: React.PropTypes.func.isRequired,
    isSelected: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function() {
    return {
      isSelected: false
    };
  },

  getInitialState: function() {
    return {
      hovering: false,
      child: this.props.child === 1
    };
  },

  hoverEvent: function(e) {
    if (e.type === "mouseenter") {
      this.setState({hovering: true})
    }
    else {
      this.setState({hovering: false})
    }
  },

  render: function() {
    if (this.state.child) {
      var liStyle = {
        paddingLeft: "75px",
        background: "transparent"
      }
    }
    else {
      var liStyle = {
        background: "transparent"
      }
    }
    if (this.props.isSelected || this.state.hovering) {
      liStyle["background"] = "#343436";
      liStyle["color"] = "#fff";
    }
    return (
      <li className="nav-item"
        id={this.props.name}
        onClick={this.props.click}
        onMouseEnter={this.hoverEvent}
        onMouseLeave={this.hoverEvent}
        style={liStyle}>{this.props.name}
     </li>
   );
 }
});

function setParams({ link = ""}) {
  const searchParams = new URLSearchParams();
  searchParams.set("link", link);
  return searchParams.toString();
}

export default React.createClass({

  displayName : "sdk-doc-utils",

  getInitialState: function() {
    var selectedItem = null;
    var scrollingEl = null;
    return ({selectedItem, scrollingEl});
  },

  componentDidMount: function() {
    sidebarOnClicks()
    var scrollingEl = document.getElementById("scrollingEl");
    this.setState({scrollingEl: scrollingEl})
  },


  clickHandler: function(event) {
    scrollTo(this.state.scrollingEl, event);
    var url = setParams({link: event.target.id})
    this.props.history.push(`?${url}`);

    this.setState({selectedItem: _.findIndex(
      this.props.data,
      function(d) {
        return d.name === event.target.id;
      }
      )
    })
  },

  render: function() {
    var titleTag = ""
    if(this.props.pageTitle) {
      titleTag = this.props.pageTitle
    }
    var items = this.props.data.map(function (item, idx) {
      if(decodeURIComponent(window.location.hash).indexOf(item.name) != -1) {
        titleTag = titleTag + " | " + item.name
      }
      var is_selected = (this.props.selectedItem || this.state.selectedItem) === idx;

      var baseURL = "";
      var hasLink = window.location.href.indexOf("?") != -1

      if(hasLink) {
        baseURL = window.location.href.slice(0, window.location.href.indexOf("?"));
      }
      else {
        baseURL = window.location.href;
      }

      var lastSlashIndex = baseURL.lastIndexOf("/")
      var page = baseURL.slice(lastSlashIndex, baseURL.length);

      if(item.disableEl) {
        return (
          <Link key={idx} href="javascript:void(0)">
            <LI
              name={item.name}
              child={item.child || ""}
              isSelected={is_selected}
              click={function(){}}
            />
          </Link>
        );
      }
      else {
        return (
          <Link key={idx} to={{pathname: page + "?link=" + item.name}}>
            <LI
              name={item.name}
              child={item.child || ""}
              isSelected={is_selected}
              click={function(){}}
            />
          </Link>
        );
      }
    }.bind(this));

    if(titleTag != "") {
      document.title = "FaceTec | " + titleTag
    }
    else {
      document.title = "FaceTec - Developer Account"
    }

    return (
      <div>
        <form className="form-search form-inline" onSubmit={this.handleSearchSubmit}>
          <div className="input-group">
              <input type="text" className="form-control" ref="search" id="search" placeholder="Search Docs..." />
              <span className="input-group-addon" onClick={this.handleSearchSubmit}><i className="glyphicon glyphicon-search"></i></span>
          </div>
        </form>
        <ul className={this.props.className}>
          {items}
        </ul>
      </div>
    );
  },
  handleSearchSubmit: function(event) {
    event.preventDefault();

    window.location.href = '/#/search?key=' + this.refs.search.value;
  }
});



export function initDeepLinkData(props) {
  var scrollToElement;
  if(props && props.location && props.location.search) {
    scrollToElement = queryString.parse(props.location.search).link;

    // update element id for previous hash url
    scrollToElement = previousHashURL(props.route.path, scrollToElement);

    setParams({link: scrollToElement})
  }
  return scrollToElement;
}

export function scrollTo (scrollingEl, event) {
  var myId = document.getElementById(event.target.id);
  scrollingEl.scrollTop = myId.offsetTop  - 90;
  event.preventDefault();
}

export function mountCode(that) {
  that.scrollingEl = document.getElementById("scrollingEl");
  var scrollingEl = document.getElementById("scrollingEl");
  var navMenuParent = document.getElementById("stickyParent");
  var navMenu = document.getElementById("sticky");
  var data = [];

  var currentLink = ""
  var hasLink = window.location.href.indexOf("?") != -1
  if(hasLink)
    currentLink = decodeURIComponent(window.location.href.slice(window.location.href.indexOf("link=")+5));



  _.forEach(that.state.data, function(n, key) {
      if(currentLink == n.name) {
        data.push({name:n.name, pos: document.getElementById(n.name), disableEl: true});
      }
      else {
        data.push({name:n.name, pos: document.getElementById(n.name)});
      }
  });
  that.setState({scrollingEl: scrollingEl,
                 navMenuParent: navMenuParent,
                 navMenu : navMenu,
                 data: data
  });
  that.scrollToGuide = that.props.location.query.location;
  scrollingEl.scrollTop = 0;

  var timeout = 500;
  if(that.state.deepLinkTimeout) {
    timeout = that.state.deepLinkTimeout;
  }

  if(that.state.scrollToElement) {
    setTimeout(function(){
      if(document.getElementById(that.state.scrollToElement)) {
        var extraOffset = 40;
        var classname = $("#" + that.state.scrollToElement).attr('class');
        if(classname == "inside-section") {
          extraOffset = 190;
        }
        that.scrollingEl.scrollTop = document.getElementById(that.state.scrollToElement).offsetTop + extraOffset;
      }
    },timeout);
  }

  // Apply deep link url icon to all headers
  var page = that.props.route.path;

  if(that.state.deepLinkTimeout) {
    // wait until All components get laoded after api call (i.e. account page)
    setTimeout(function(){
      deepLinkUrl(page);
    },timeout);
  }
  else {
    deepLinkUrl(page);
  }

  // Highlight current page in sidebar
  // 1st level link
  $(".ac-label a[href$='" + page+ "']").parent().addClass("menu-highlighted");
  // 2nd level link
  $(".ac-content a[href$='" + page+ "'] div").addClass("menu-highlighted");
  $(".ac-content a[href$='" + page+ "']").parent().siblings(".ac-input").prop("checked", true);

  // href with link value in it
  $(".ac-content a[href$='" + page + "?link=" + currentLink + "'] div").addClass("menu-highlighted");

};

export function urlChangeHandler() {
  if(window.location.href.indexOf("?") != -1) {
    var currentLink = decodeURIComponent(window.location.href.slice(window.location.href.indexOf("link=")+5));
    if(currentLink && document.getElementById(currentLink) != null) {
      // change highlight sidebar menu for href with link value in it
      var hashLink = decodeURIComponent(window.location.href.slice(window.location.href.indexOf("#")+1))
      var selectedMenuItem = $('div.menu-highlighted').parent().attr('href');
      if(selectedMenuItem && selectedMenuItem.indexOf("link=") > 0) {
        $('div.menu-highlighted').removeClass("menu-highlighted");
      }

      $(".ac-content a[href$='" + hashLink + "'] div").addClass("menu-highlighted");

      var extraOffset = 40;
      var classname = $("#" + currentLink).attr('class');

      if(classname == "inside-section") {
        extraOffset = 190;
      }
      $("body").scrollTop((document.getElementById(currentLink).offsetTop  + extraOffset));
    }
  }
};

// Append deep link url to all headers
export function deepLinkUrl(page) {
  $("h2, h3, h4").each(function(i, el) {
    var id = $(el).attr('id');
    var tab = "";

    // Add tab value in url for release notes page
    if(page == "release-notes" && $(el).parent("section").parent("div").attr('id')) {
      var parentId = $(el).parent("section").parent("div").attr('id');
      if(parentId && parentId.indexOf("-tab") > -1) {
        tab = "tab=" + parentId.replace("-tab", "") + "&";
      }
    }

    if(id && page) {
      $(el).append($("<a />").addClass("header-link").attr("href", "#/" + page + "?" + tab + "link=" + id).html('<i class="material-icons">link</i>'));
    }
  });
}

export function sidebarOnClicks() {
  $(".open-menu").click(function() {
    $("#sidebar").addClass("show-menu");
    $("body").addClass("pause");
    $("html").addClass("pause");
  });

  $(".close-menu").click(function() {
    $("#sidebar").removeClass("show-menu");
    $("body").removeClass("pause");
    $("html").removeClass("pause");
  });

  $("#sidebar a").click(function() {
    $("#sidebar").removeClass("show-menu");
    $("body").removeClass("pause");
    $("html").removeClass("pause");
  });

  $("#sidebar .nav-item").click(function() {
    $("#sidebar").removeClass("show-menu");
    $("body").removeClass("pause");
    $("html").removeClass("pause");
  });
}

function previousHashURL(page, link) {
  // Add value of previous hash
  // {page-url :  {
  //    previous-hash: new-hash
  // }}
  var previousHashUrlMapping = {
    "faq": {
      "what-devices-and-os-levels-are-supported-for-ios-previous": "what-devices-and-os-levels-are-supported-for-ios",
      "what-versions-and-platforms-are-supported-previous": "what-versions-and-platforms-are-supported"
    },
    "technical-specs": {
      "read-first-policy-and-guidance-previous": "read-first-policy-and-guidance"
    }
  }

  for (const pageUrl in previousHashUrlMapping) {
    for (const previousHash in previousHashUrlMapping[pageUrl]) {
      if(previousHash == link) {
        return previousHashUrlMapping[pageUrl][previousHash];
      }
    }
  }
  return link;
}



// WEBPACK FOOTER //
// ./src/js/utilities/sdk-doc-utils.jsx